import _ from 'lodash';
import { DateTime } from 'luxon';
import { Note } from '../../types/Note';

/**
 * Groups notes by parent-child relationships and sorts children by `created_at`.
 * @param notes Array of notes to group.
 * @returns Array of top-level notes with their children sorted by `created_at`.
 */
export const groupNotesByParent = (notes: Note[]): Note[] => {
  if (!notes?.length) return [];

  // Ensure only notes with UUIDs are processed
  const validNotes = notes.filter((note) => note.uuid !== undefined);

  // Create a map of notes indexed by their UUID
  const notesByUuid = _.keyBy(validNotes, 'uuid');

  // Get all children (notes with parent_uuid) and group them by their parent_uuid
  const groupedChildren = _.groupBy(_.filter(validNotes, 'parent_uuid'), 'parent_uuid');

  // Assign children to their respective parents
  Object.entries(groupedChildren).forEach(([parentUuid, children]) => {
    if (notesByUuid[parentUuid]) {
      notesByUuid[parentUuid].children = _.sortBy(children, (child) => DateTime.fromISO(child.created_at ?? '').toMillis());
    }
  });

  // Return top-level notes (notes without parent_uuid), ensuring children are initialized
  return _.map(
    _.filter(validNotes, (note) => !note.parent_uuid),
    (note) => ({
      ...note,
      children: notesByUuid[note.uuid!]?.children || [],
    })
  );
};
